import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { editCivilCaseAppeal2 } from "services/civilCaseComplaintDetailService";
import { editCivilCaseComplaint } from "services/civilCaseComplaintService";
import { CivilCaseAppeald, CivilCaseComplaint } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";

type Props = {
  isEdit?: boolean;
  compliant?: CivilCaseComplaint;
  appeal?: CivilCaseAppeald;
  onClose: (refetch: boolean) => void;
};

const CivilCaseOrgUnitForm: FC<Props> = ({
  isEdit = false,
  compliant,
  appeal,
  onClose,
}) => {
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [lowerOrgId, setLowerOrgId] = useState("");

  const validateForm = () => {
    if (!lowerOrgId) return "Org Unit is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setLoading(true);

    const api = compliant ? editCivilCaseComplaint : editCivilCaseAppeal2;

    api({
      id: compliant?.id || appeal?.id || 0,
      org_unit_id: lowerOrgId,
      status: compliant ? "forwarded_to_cordinator" : "forwarded_to_management",
      complaint: appeal ? appeal?.complaint : undefined,
      parent_appeal: appeal ? appeal?.parent_appeal : undefined,
    })
      .then(() => {
        showTooltip(
          isEdit ? "Successfully Updated!" : "Successfully Submitted!",
          "success",
        );
        navigate("/civil-case-complaint", { replace: true });
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail || errorHandlerOnForm(error),
          "error",
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="w-full bg-white rounded-xl">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900 mb-1">Org Unit</h2>
        <p className="text-sm text-gray-600">Add Organizaional Unit</p>
      </div>

      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Org Unit *
            </label>
            <select
              value={lowerOrgId}
              onChange={(e) => {
                setLowerOrgId(e.target.value);
              }}
              className="w-full border border-gray-300 rounded-lg bg-gray-50 p-3 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-all"
            >
              <option value="">Select Org Unit</option>
              {(loginData?.structure?.departments?.tree || []).map((unit) => (
                <option key={unit?.uu_id} value={unit?.uu_id}>
                  {unit?.unit_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
          <button
            type="button"
            className="px-6 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200"
            disabled={loading}
            onClick={(e) => {
              e.preventDefault();
              onClose(false);
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-6 py-2.5 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg hover:from-green-700 hover:to-green-800 transition-all flex items-center shadow-sm hover:shadow"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="animate-spin">{LoadingIcon}</span>
                Processing...
              </>
            ) : (
              "Forward to Coordinator"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CivilCaseOrgUnitForm;
